import moment from 'moment';
import { __, isNil, allPass, equals, length, compose, either, both, lte, gte, nth } from 'ramda';
/*
  Helper functions to display dates in different formats.
  Helps to easily keep date displays consistent and formats maintainable.
 */

export const validate = date => !isNil(date) && moment(new Date(date)).isValid();

const defaultEditTime = 24;
const addEditTime = date => moment(date).add(defaultEditTime, 'h');

export const formatDate = (date, format = 'DD.MM.YYYY') => (validate(date) ? moment(date).format(format) : null);

export const formatHeaderDate = date => (validate(date) ? moment(date).format('Do MMMM YYYY') : null);

export const formatTimeLeft = date => (validate(date) ? moment().to(addEditTime(date)) : null);

export const formatTimeLeftSimple = date => {
  if (validate(date)) {
    let timeLeftMin = -moment().diff(addEditTime(date), 'm');
    let hrsLeft = Math.floor(timeLeftMin / 60);
    timeLeftMin = timeLeftMin - hrsLeft * 60;
    /*
    const timeLeft = moment(hrsLeft + ':' + timeLeftMin, 'H:m').format('HH:mm');
    console.log(hrsLeft + ':' + timeLeftMin,timeLeft);
    return timeLeft;
    */
    return { hrs: hrsLeft, mins: timeLeftMin };
  } else {
    return null;
  }
};

export const editTimeLeft = date => (validate(date) ? moment().isBefore(addEditTime(date)) : null);

export const notOlderThanOneMonth = date => (validate(date) ? moment().isBefore(moment(date).add(1, 'M')) : null);

export const dateValue = date => (validate(date) ? moment(date).valueOf() : null);

export const parseSQMSDate = date => (date.year ? moment([date.year, date.month - 1 || 0, date.day || 0]) : 0);

export const getMonthName = idx => (both(gte(idx, 0), lte(idx, 11)) ? moment.months()[idx] : null);

// A method to check whether a value is (most likely) a partial date.
// This is not 100% accurate every time, but the fail rate is negligible.
// In future versions, we must either change how edit log is rendered or pair values in forms with value types.
// However, in practice this will work.

// The function takes one value as an argument, all the conditionals in the list must pass for it to return true.
// Firstly, it checks that length is 2 (tuple)
// Secondly, it checks that the first item in the tuple is between 1900 and 2100
// Thirdly, it checks that the second value is null, undefined or between 0 and 11

export const isPartial = allPass([
  compose(equals(2), length),
  compose(both(gte(__, 1900), lte(__, 2100)), nth(0)),
  compose(either(isNil, both(gte(__, 0), lte(__, 11))), nth(1)),
]);

// Helper function to format partial dates.
// Only returns something is value is not null or undefined and it is a valid partial date.
export const formatPartial = partial =>
  !isNil(partial) && isPartial(partial) && `${partial[0] || ''}${partial[1] ? `, ${getMonthName(partial[1])}` : ''}`;

// Helper function to format diagnosis date
export const formatDgDate = date => {
  if (!date[0]) return ''; // No year, return empty string
  if (!date[1] && !date[2]) return date[0]; // No full date, return only year
  return `${date[2]}.${date[1]}.${date[0]}`; // Return full date as dd.mm.yyyy
};
